import { IBulkUploadUnit } from "./bulk-upload-validation/bulk-upload-invitation-routes";
import { ICommunityFeaturesUpdateRequest } from "./community-admin/community-settings";
import { isArray, isBoolean, isNumber, isString } from "./general-utility";
import { IPostCommunityNominationRequest } from "./interfaces-phase2/community-nominations/sub-routes/nominate-user";
import { IStripeSubscriptionAddress } from "./stripe-route/stripe-route";
import { IValidatorInterface } from "./validator-interface";

// This file contains all the Utility tools to validate the inputs sent from the user End
export class ValidationUtility {
	public static wrapper(
		body: any,
		params: IValidatorInterface
	): { validState: boolean; body: any; errorMessage?: string } {
		let newBody: any = {};
		for (let i in params) {
			let param = params[i];
			let field = body[i];

			//If its a non required field or required is not specified
			if ((param.required !== true) && (field === undefined || field === null || field === "")) {
				newBody[i] = field
				continue;
			}

			let validState = param.function(field, ...param.params);
			if (param.keepRawValue) newBody[i] = field;
			else newBody[i] = validState;
			if (
				validState === undefined ||
				(typeof validState === "number" && Number.isNaN(validState))
			) {
				return {
					validState: false,
					body: undefined,
					errorMessage: param.customMessage
						? param.customMessage
						: `Validation error in field ${i}`
				};
			}
		}
		return {
			validState: true,
			body: newBody
		};
	}

	public static validateDomain = (domain) => {
		// Regular expression to validate a domain with at least one subdomain
		const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

		// Check if the domain matches the regex and is not a root domain
		if (!domainRegex.test(domain)) {
			// throw new Error("Invalid domain. The domain must include at least one subdomain (e.g., www.networked.co).");
			return undefined
		}

		// Split the domain to check for subdomains
		const parts = domain.split('.');
		if (parts.length < 3) {
			// throw new Error("Invalid domain. Root domains (e.g., networked.co) are not allowed.");
			return undefined
		}

		return domain; // Valid domain
	};

	public static validateUserHandle(value: string): string | undefined {
		if (!value) return undefined;
		if (!value.match(/^[a-zA-Z0-9\_\.]+$/)) return undefined;
		if (value.length >= 3 && value.length <= 20) {
			return value;
		} else {
			return undefined;
		}
	}
	public static customInterestValidator(value: any) {
		if (!isArray(value)) return;
		for (let i in value) {
			let v: any = value[i];
			if (!isString(v.id) || !isBoolean(v.isPublic)) return undefined;
		}
		return value;
	}
	public static validateAny(value: any): any {
		console.log(value)
		return value;
	}

	//Returns true on valid string. False on invalid
	public static validateStringFields(
		value: string,
		min: number,
		max: number
	): string | undefined {

		// console.log("min", min);

		if (value === undefined || value === null) {
			var response = {
				status: 400,
				description:
					"Invalid input, the login credentials are not valid."
			};
			return undefined;
		}
		if (value.length >= min && max == -1 ? true : value.length <= max) {
			// console.log("coming");

			return value;
		} else {

			// res.status(400);
			// res.end(JSON.stringify(response));
			return undefined;
		}
	}

	public static validateArrayStringFields(
		value: string[],
		min: number,
		max: number
	): string[] | undefined {

		// console.log("min", min);
		let c = 0;
		for (let i = 0; i < value.length; i++) {
			if (value[i] === undefined) {
				var response = {
					status: 400,
					description:
						"Invalid input, the login credentials are not valid."
				};
				return undefined;
			}
			if (value[i].length >= min && max == -1 ? true : value[i].length <= max) {
				continue
			} else {
				c++
			}
		}
		if (c > 0)
			return undefined
		return value
	}
	public static validateArrayNumberFields(
		value: number[],
	): number[] | undefined {
		if (value == undefined)
			return undefined
		// console.log("min", min);
		let c = 0;
		for (let i = 0; i < value.length; i++) {
			if (!isNaN(value[i])) {
				continue
			}
			else {
				c++
			}
		}
		if (c > 0)
			return undefined
		return value
	}

	public static validateEmail(email: string): string {
		if (!email) return undefined;
		if (
			!email.match(
				/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
			)
		)
			return undefined;
		return email.toLowerCase();
	}
	public static validatePassword(password: string): string | undefined {
		if (!password) return undefined;
		if (
			!(
				password.match(/[A-Z]/) &&
				password.match(/[a-z]/) &&
				password.match(/[0-9]/) &&
				password.match(/[^A-Za-z0-9]/)
			)
		)
			return undefined;
		return password;
	}
	public static validatePhoneNumber(phone: string): boolean | string {
		if (!phone) return undefined;
		if (!phone.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)) return false;

		return phone;
	}
	public static validateNumber(n: any): number {
		if (n === isNaN) return NaN;
		if (n === "") return NaN
		if (isNumber(n)) return n;
		if (n === undefined || isNaN(parseInt(n))) return NaN;
		return parseInt(n);
	}

	public static validateEnum(value: any, enumType: any): number | undefined {
		if (value === undefined) return undefined;
		const num = ValidationUtility.validateNumber(value);
		if (isNaN(num)) return undefined;
		// Check if the value exists in the enum
		if (Object.values(enumType).includes(num)) {
			return num;
		}
		return undefined;
	}

	public static validateArrayEnum(value: any[], enumType: any): number[] | undefined {
		if (!isArray(value)) return undefined;
		const validatedValues = value.map(v => ValidationUtility.validateEnum(v, enumType));
		if (validatedValues.includes(undefined)) return undefined;
		return validatedValues;
	}

	public static validateFloat(n: string): number {
		if (!n || isNaN(parseFloat(n))) return undefined;
		return parseFloat(n);
	}

	// To check valid objectId or not (clients sometimes send a one-id array, e.g. ["..."] )
	public static validateObjectId(id: string | string[] | undefined | null): string | undefined {
		if (id == null) return undefined
		if (Array.isArray(id)) {
			if (id.length === 0) return undefined
			return ValidationUtility.validateEntityId(id[0] as string)
		}
		if (typeof id !== "string") return undefined
		if (id.length > 0) {
			return ValidationUtility.validateEntityId(id as string)
		}
		else {
			return undefined
		}
	}

	// To check valid slug/readableID
	public static validateReadableId(readableId: string): string {
		if (readableId && readableId.length > 0) {
			return readableId
		} else {
			return undefined
		}
	}

	// To check valid objectId or not
	public static validateObjectArrayId(ids: string[]): string[] {
		if (!isArray(ids))
			return undefined
		for (let index = 0; index < ids.length; index++) {
			const element = ids[index];
			let checkId = ValidationUtility.validateEntityId(element);
			if (!checkId) return undefined;
		}
		return ids;
	}

	/** Mongo ObjectId (24 hex) or UUID (Prisma / Postgres string ids). */
	public static validateEntityId(id: string): string {
		if (id == undefined || id.length === 0) {
			return undefined;
		}
		const mongo24 = /^[0-9a-fA-F]{24}$/;
		const uuid =
			/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/i;
		if (mongo24.test(id) || uuid.test(id)) {
			return id;
		}
		return undefined;
	}

	public static validateEntityArrayId(ids: string[]): string[] {
		if (!isArray(ids)) {
			return undefined;
		}
		for (let index = 0; index < ids.length; index++) {
			if (ValidationUtility.validateEntityId(ids[index]) === undefined) {
				return undefined;
			}
		}
		return ids;
	}
	public static validateObjectKey(object: any[]): any[] {

		for (let i = 0; i < object.length; i++) {
			console.log("object[i].reference", typeof (object[i]));
			if (!object[i].reference || !object[i].rawValue)
				return undefined;

		}
		return object;
	}
	public static validateEmailArrayFields(ids: string[]): string[] {
		// console.log("ids", ids);

		for (let i = 0; i < ids.length; i++) {
			ids[i] = ValidationUtility.validateEmail(ids[i])
			if (!ids[i]) return undefined;
			// ids[i].toLowerCase()
		}
		// console.log(ids);

		return ids;
	}

	public static validateBoolean(val: boolean): boolean {
		// console.log("typeOdf", !isBoolean(val));

		// @ts-ignore
		if (val == "true")
			return true
		//@ts-ignore
		else if (val == "false")
			return false

		if (!isBoolean(val)) return undefined;
		// console.log("gaurav");

		return val;
	}

	public static validateObjectKeyStringValues(value: any) {
		if (!value) return true;

		if (typeof value !== "object" || Array.isArray(value)) {
			return false;
		}

		for (const key in value) {
			if (typeof value[key] !== "string") {
				return false;
			}
		}

		return true;
	}

	public static validateObject(obj: {
		email: boolean,
		app: boolean
	}): object {
		if (!obj) return undefined
		if (ValidationUtility.validateBoolean(obj.email) == undefined)
			return undefined;
		if (ValidationUtility.validateBoolean(obj.app) == undefined)
			return undefined;
		;
		return obj
	}
	public static validateRestrictTagAarrayObject(obj: {
		fromTag: any,
		toTag: any,
		restrictions: string[]
	}[]): object[] {
		for (let i = 0; i < obj.length; i++) {
			if (!obj) return undefined
			if (ValidationUtility.validateObjectId(obj[i].fromTag) == undefined) return undefined;
			if (ValidationUtility.validateObjectId(obj[i].toTag) == undefined) return undefined;
			if (!isArray(obj[i].restrictions)) return undefined;
		}
		return obj
	}

	public static validateAnalyticsPopupObject(obj): object[] {
		console.log("object", obj);

		for (let i = 0; i < obj.length; i++) {
			if (!obj) return undefined
			if (ValidationUtility.validateAny(obj[i].graphId) == undefined) return undefined;
			if (ValidationUtility.validateBoolean(obj[i].state) == undefined) return undefined;
		}
		return obj
	}
	public static validateUrl(url: string): boolean | string {
		if (!url) return undefined;
		// if (!url.match(/^[a-z](?:[-a-z0-9\+\.])*:(?:\/\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:])*@)?(?:\[(?:(?:(?:[0-9a-f]{1,4}:){6}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|::(?:[0-9a-f]{1,4}:){5}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|v[0-9a-f]+\.[-a-z0-9\._~!\$&'\(\)\*\+,;=:]+)\]|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3}|(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=])*)(?::[0-9]*)?(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@]))*)*|\/(?:(?:(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@]))+)(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@]))*)*)?|(?:(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@]))+)(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@]))*)*|(?!(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@])))(?:\?(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@])|[\x{E000}-\x{F8FF}\x{F0000}-\x{FFFFD}\x{100000}-\x{10FFFD}\/\?])*)?(?:\#(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@])|[\/\?])*)?$/i))
		// 	return false;
		// if (url.startsWith("http") || url.startsWith("https") || url.startsWith("www"))
		// return url;
		if (url.match(/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/))
			return url
		return undefined
	}

	public static validateBulkFeatureUpdateArrayDataObject(obj: ICommunityFeaturesUpdateRequest[]): object[] {
		for (let i = 0; i < obj.length; i++) {
			let ele = obj[i]
			if (!ValidationUtility.validateObjectId(ele.featureId)) return undefined
			if (ValidationUtility.validateBoolean(ele.access) == undefined) return undefined
			if (ValidationUtility.validateBoolean(ele.open) == undefined) return undefined

		}
		return obj
	}

	public static validateBulkNominationCreate(obj: IPostCommunityNominationRequest[]): object[] {
		if (!obj) return undefined
		for (let i = 0; i < obj.length; i++) {
			let ele = obj[i]
			if (ValidationUtility.validateStringFields(ele.fullName, 1, -1) == undefined) return undefined
			if (ValidationUtility.validateEmail(ele.email) == undefined) return undefined;
			if (ValidationUtility.validateStringFields(ele.designation, 1, -1) == undefined) return undefined
			if (!ValidationUtility.validateObjectId(ele.affilationTag)) return undefined
			if (ValidationUtility.validateStringFields(ele.currentOrganization, 1, -1) == undefined) return undefined
			if (ValidationUtility.validateStringFields(ele.location, 1, -1) == undefined) return undefined
			if (ValidationUtility.validateStringFields(ele.nominationNote, 1, -1) == undefined) return undefined
		}
		return obj
	}

	public static validateBulkInvitationArrayDataObject(obj: IBulkUploadUnit[]): object[] {

		for (let i = 0; i < obj.length; i++) {
			let ele = obj[i]
			if (!obj) return undefined

			if (ValidationUtility.validateStringFields(ele.name, 1, -1) == undefined) return undefined
			if (ValidationUtility.validateEmail(ele.email) == undefined) return undefined;
			if (ValidationUtility.validateObjectId(ele.affiliationTag) == undefined) return undefined;

			if (ele.title) if (ValidationUtility.validateStringFields(ele.title, 1, -1) == undefined) return undefined;
			if (ele.phoneNo) if (ValidationUtility.validatePhoneNumber(ele.phoneNo) == undefined || !(ValidationUtility.validatePhoneNumber(ele.phoneNo))) return undefined;
			if (ele.about) if (ValidationUtility.validateStringFields(ele.about, 1, -1) == undefined) return undefined;
			if (ele.industry) if (ValidationUtility.validateObjectArrayId(ele.industry) == undefined) return undefined;
			if (ele.location) if (ValidationUtility.validateStringFields(ele.location, 1, -1) == undefined) return undefined;
			if (ele.imageUrl) if (ValidationUtility.validateStringFields(ele.imageUrl, 1, -1) == undefined) return undefined;
			if (ele.linkedInUrl) if (ValidationUtility.validateUrl(ele.linkedInUrl) == undefined) return undefined;
			if (ele.calendlyUrl) if (ValidationUtility.validateUrl(ele.calendlyUrl) == undefined) return undefined;

			if (ele.primaryCompany) if (ValidationUtility.validateStringFields(ele.primaryCompany, 1, -1) == undefined) return undefined;
			if (ele.primaryEducation) if (ValidationUtility.validateStringFields(ele.primaryEducation, 1, -1) == undefined) return undefined;

			// if (ele.note) if (ValidationUtility.validateStringFields(ele.note, 1, -1) == undefined) return undefined;

			if (!isArray(ele.experiences))
				return undefined
			if (!isArray(ele.educations))
				return undefined

			for (let i = 0; i < ele.experiences.length; i++) {
				const e = ele.experiences[i];
				if (e.description) if (ValidationUtility.validateStringFields(e.description, 1, -1) == undefined) return undefined;
				if (e.endDate) if (ValidationUtility.validateNumber(e.endDate) == undefined || isNaN(ValidationUtility.validateNumber(e.endDate))) return undefined;
				if (e.startDate) if (ValidationUtility.validateNumber(e.startDate) == undefined || isNaN(ValidationUtility.validateNumber(e.startDate))) return undefined;
				if (ValidationUtility.validateStringFields(e.name, 1, -1) == undefined) return undefined;
				if (e.title) if (ValidationUtility.validateStringFields(e.title, 1, -1) == undefined) return undefined;
				if (e.employmentType) if (ValidationUtility.validateStringFields(e.employmentType, 1, -1) == undefined) return undefined;
			}
			for (let i = 0; i < ele.educations.length; i++) {
				const e = ele.educations[i];
				if (ValidationUtility.validateStringFields(e.name, 1, -1) == undefined) return undefined;
				if (e.fieldOfStudy) if (ValidationUtility.validateStringFields(e.fieldOfStudy, 1, -1) == undefined) return undefined;
				if (e.graduationDate) if (ValidationUtility.validateNumber(e.graduationDate) == undefined || isNaN(ValidationUtility.validateNumber(e.graduationDate))) return undefined;
			}
		}
		return obj
	}

	public static validateModelStatus(status: number, validStatus: number[]): number {
		let num: number = +status
		if (validStatus.indexOf(num) >= 0)
			return num
		else
			return undefined
	}

	public static validateUserTypeN(type: number, validUserType: number[]): number {
		let num: number = +type
		if (validUserType.indexOf(num) >= 0)
			return num
		else
			return undefined
	}

	public static validateStripeAddressObject(obj: IStripeSubscriptionAddress): IStripeSubscriptionAddress {
		if (!obj) return undefined;
		if (ValidationUtility.validateStringFields(obj.country, 1, -1) == undefined) return undefined;
		if (ValidationUtility.validateStringFields(obj.state, 1, -1) == undefined) return undefined;
		if (ValidationUtility.validateStringFields(obj.city, 1, -1) == undefined) return undefined;
		if (ValidationUtility.validateStringFields(obj.line1, 1, -1) == undefined) return undefined;
		if (ValidationUtility.validateStringFields(obj.postal_code, 1, -1) == undefined) return undefined;
		return obj;
	}
}


// p2p GET is missing designation, promary company, location
// p2p POST is missing image, designation, promary company, location
